import React from 'react'

import imageUrl from 'assets/images/imageGH.png'
import BrandIcon from 'parts/IconText';

export default function HeroContact() {

    return (

        <div className="container-fluid px-3 px-md-5 mt-5">
            <section
                className="bg-dark text-white d-flex flex-column flex-md-row align-items-center justify-content-between"
                style={{
                height: '55vh',
                background: `url(${imageUrl}) no-repeat center center / cover`,
                borderRadius: '15px',
                marginTop: '80px',
                overflow: 'hidden',
                }}
            >
                <div className="p-4 text-center text-md-start">
                <BrandIcon />
                <h1 className="fw-bold mt-3">Hubungi Kami</h1>
                </div>
            </section>
        </div>
    )
}
